import React, { useEffect, useMemo, useState } from 'react';
import FullCalendar from '@fullcalendar/react';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import CustomDialog from '../../../../shared/Overlays/CustomDialog';
import CustomCard, { CustomGridLayout } from '../../../../shared/Cards/CustomCard';
import { CustomCalenderInput, CustomDropDown, CustomTextArea } from '../../../../shared/Input/AllInputs';
import formValidation from '../../../../utils/validations';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { Skeleton } from 'primereact/skeleton';

import { useParams } from 'react-router-dom';
import useDepartments from '../../../../hooks/Employees/useDepartments';
import useEmployees from '../../../../hooks/Employees/useEmployees';
import {
    addOrUpdateDepartmentShift,
    copyDepartmentEmployeeShifts,
    getDepartmentEmployeeShifts,
} from '../../../../redux/actions/EmployeeSettings/departmentEmployeeShiftAction';
import FormPage from '../../../../shared/Layout/FormPage';

const EmployeeShiftCalendar = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    let { departmentsDropdown } = useDepartments();
    let { employeesDropdown } = useEmployees();

    const [shifts, setShifts] = useState([]);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [data, setData] = useState({ availability: '', note: '' });
    const [data1, setData1] = useState({ employee: '', department: id });

    const [loading, setLoading] = useState(false);
    let { department, employee } = data1;

    useEffect(() => {
        if (department && employee) {
            dispatch(
                getDepartmentEmployeeShifts(department, employee, setLoading, (all) => {
                    setShifts(all);
                }),
            );
        }
    }, [dispatch, department, employee]);

    const formatTime = (date) => new Date(date).toLocaleTimeString();
    const getDayName = (dayIndex) => ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][dayIndex];

    const onSelectEvent = (info) => {
        const id = info.event.id;
        const title = info.event.title;
        const start = info.event.start;
        const end = info.event.end;
        const dayOfWeek = start.getDay();
        const availability = info.event.extendedProps.availability || '';
        const note = info.event.extendedProps.note || '';

        setData({
            id,
            title,
            start,
            end,
            dayOfWeek,
            availability,
            note,
        });
        setModalIsOpen(true);
    };

    const [loadingUpdate, setLoadingUpdate] = useState(false);

    const onAddOrUpdateShift = () => {
        if (data?.id) {
            let payload = {
                availability: data.availability,
                note: data.note,
                employee,
            };
            dispatch(
                addOrUpdateDepartmentShift(data?.id, payload, setLoadingUpdate, (newShift) => {
                    let index = shifts.findIndex((shift) => shift._id === data.id);
                    if (index !== -1) {
                        setShifts((prev) => {
                            let updatedShifts = [...prev];
                            updatedShifts[index]['availability'] = payload.availability;
                            updatedShifts[index]['note'] = payload.note;
                            return updatedShifts;
                        });
                    }
                    setModalIsOpen(false);
                    setData({ availability: '', note: '' });
                }),
            );
        }
    };

    const handleChange = ({ name, value }) => {
        const formErrors = formValidation(name, value, data);
        setData((prev) => ({ ...prev, [name]: value, formErrors }));
    };
    const handleChange1 = ({ name, value }) => {
        const formErrors = formValidation(name, value, data1);
        setData1((prev) => ({ ...prev, [name]: value, formErrors }));
    };

    const renderEventContent = (eventInfo) => {
        const { title, start, end, id, extendedProps } = eventInfo.event;

        return (
            <div style={{ padding: '5px', fontSize: '0.85rem', lineHeight: 1.5, height: '100%', overflowY: 'auto' }}>
                <div style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>
                    <i className="pi pi-clock" style={{ marginLeft: '4px', fontSize: '0.75rem' }} /> {eventInfo.timeText}
                </div>
                <div style={{ fontSize: '1rem', margin: '2px 0' }}>{title}</div>
                {extendedProps.note && <div style={{ fontSize: '0.75rem' }}>Note: {extendedProps.note}</div>}
            </div>
        );
    };

    const formatShiftForCalendar = (shift) => {
        const start = `${shift.date}T${shift.startTime}`;
        const end = `${shift.date}T${shift.endTime}`;
        return {
            id: shift._id,
            title: shift.title,
            start,
            end,
            color: getColorByCondition(shift),
            extendedProps: {
                shiftId: shift._id,
                staffRequired: shift.staffRequired,
                assignedEmployees: shift.assignedEmployees,
                availability: shift.availability,
                note: shift.note,
                shiftKey: shift.shiftKey,
                minutes: shift.minutes,
            },
        };
    };
    const _shifts = useMemo(() => {
        return shifts.map((shift) => formatShiftForCalendar(shift));
    }, [shifts]);

    const onCloseModal = () => {
        setModalIsOpen(false);
        setData({ title: '', start: '', end: '', dayOfWeek: '', staffRequired: 1, minutes: 0, employees: [] });
    };

    const availabilityOptions = [
        { name: 'Preferred', value: 'preferred_and_available' },
        { name: 'Not Preferred but Available', value: 'not_preferred_but_available' },
        { name: 'Not Available', value: 'not_available' },
    ];

    const [copyWeekModal, setCopyWeekModal] = useState(false);
    const calendarRef = React.useRef();

    const handleCopyWeek = () => {
        const calendarApi = calendarRef?.current?.getApi();
        const view = calendarApi?.view;
        const currentStart = view?.currentStart; // JS Date object
        const currentEnd = view?.currentEnd; // JS Date object
        const startDate = moment(currentStart).format('YYYY-MM-DD');
        const endDate = moment(currentEnd).subtract(1, 'day').format('YYYY-MM-DD');
        const replaceFrom = moment(data.replaceFrom).format('YYYY-MM-DD');
        const replaceTo = moment(data.replaceTo).format('YYYY-MM-DD');

        let payload = {
            startDate,
            endDate,
            replaceFrom,
            replaceTo,
            employeeId: employee,
        };

        dispatch(
            copyDepartmentEmployeeShifts(department, payload, setLoadingUpdate, (newShifts) => {
                dispatch(
                    getDepartmentEmployeeShifts(department, employee, setLoading, (all) => {
                        setShifts(all);
                    }),
                );
                setCopyWeekModal(false);
            }),
        );
    };

    const onCopyWeek = () => {
        setCopyWeekModal(true);
        const calendarApi = calendarRef?.current?.getApi();
        const view = calendarApi?.view;
        const currentEnd = view?.currentEnd;
        setData(() => ({
            copyBy: 'shiftKey',
            replaceFrom: currentEnd,
            replaceTo: new Date(moment(currentEnd).add(6, 'days')),
        }));
    };

    return (
        <>
            <FormPage backText="Departments">
                <CustomCard col="12" title={'Employee Availablity Calendar'} className="h-full">
                    <CustomGridLayout>
                        <CustomDropDown name="department" options={departmentsDropdown} onChange={handleChange1} data={data1} />
                        <CustomDropDown name="employee" options={employeesDropdown} onChange={handleChange1} data={data1} />
                    </CustomGridLayout>
                </CustomCard>
                {department && employee && (
                    <CustomCard
                        col="12"
                        headers={
                            <>
                                <div className="flex gap-2">
                                    <div className="py-1 px-3 border-400 border-round-md mr-2 border-1 cursor-pointer text-white" onClick={onCopyWeek}>
                                        <div className="mr-2 cursor-pointer my-auto select-none">Copy Week</div>
                                    </div>
                                </div>
                            </>
                        }
                        title={'Shift Planner'}
                    >
                        <>
                            {loading ? (
                                <>
                                    <div className="flex justify-content-between mb-4">
                                        <Skeleton width="10%" height="2rem" />
                                        <Skeleton width="20%" height="2rem" />
                                        <Skeleton width="15%" height="2rem" />
                                    </div>
                                    <div className="grid mb-2">
                                        {[...Array(7)].map((day, idx) => (
                                            <div key={idx} className="col text-center font-medium">
                                                <Skeleton width="100%" height="1.2rem" />
                                            </div>
                                        ))}
                                    </div>
                                    {[...Array(6)].map((_, rowIdx) => (
                                        <div key={rowIdx} className="grid mb-2">
                                            {[...Array(7)].map((_, colIdx) => (
                                                <div key={colIdx} className="col">
                                                    <Skeleton height="3rem" className="w-full" />
                                                </div>
                                            ))}
                                        </div>
                                    ))}
                                </>
                            ) : (
                                <FullCalendar
                                    ref={calendarRef}
                                    plugins={[timeGridPlugin, interactionPlugin]}
                                    initialView="timeGridWeek"
                                    allDaySlot={false}
                                    eventClick={onSelectEvent}
                                    events={_shifts}
                                    eventContent={renderEventContent}
                                    height="auto"
                                    dayHeaderFormat={{ weekday: 'short', day: 'numeric', month: 'short' }}
                                />
                            )}
                            <br />
                        </>
                    </CustomCard>
                )}
            </FormPage>{' '}
            <CustomDialog
                visible={modalIsOpen}
                onHide={onCloseModal}
                title={`Availability for ${data?.title}`}
                onSave={onAddOrUpdateShift}
                loading={loadingUpdate}
                saveLabel="Update"
            >
                <CustomGridLayout>
                    <CustomDropDown data={data} name="availability" options={availabilityOptions} onChange={handleChange} col={12} />
                    <CustomTextArea data={data} name="note" onChange={handleChange} col={12} />
                </CustomGridLayout>
                <div className="flex justify-content-between">
                    <div>Start Time: {formatTime(data.start)}</div>
                    <div>End Time: {formatTime(data.end)}</div>
                </div>
                <div>Weekday: {getDayName(data.dayOfWeek)}</div>
            </CustomDialog>
            <CustomDialog
                visible={copyWeekModal}
                onHide={() => setCopyWeekModal(false)}
                title={'Copy Current Week Shifts'}
                loading={loadingUpdate}
                onSave={handleCopyWeek}
                saveLabel={'Copy'}
            >
                <CustomGridLayout>
                    <CustomCalenderInput data={data} name="replaceFrom" onChange={handleChange} col={12} minDate={new Date()} />
                    <CustomCalenderInput data={data} name="replaceTo" onChange={handleChange} col={12} minDate={data?.replaceFrom} />
                </CustomGridLayout>
            </CustomDialog>
        </>
    );
};

export default EmployeeShiftCalendar;
function getColorByCondition(shift) {
    let { availability } = shift;

    if (availability === 'preferred_and_available') {
        return '#588157'; //Green
    }
    if (availability === 'not_preferred_but_available') {
        return '#ffb703'; //yellow
    }
    if (availability === 'on_leave') {
        return '#219ebc'; //blue
    }
    return '#dd2d4a';
    return '#ced4da'; // gray
}
